import { IErrorResponse } from 'src/pods/system/state/types';
import { IUser } from '../interfaces';
import { IUserResponseDTO } from '../api/ResponseDtos';
import PractitionerModel from 'src/pods/user/models/PractitionerModel';
import LanguageModel from '../models/LanguageModel';
import PractitionerSpecializationModel from '../models/PractitionerSpecializationModel';

export const GET_USER_DATA_REQUEST = 'GET_USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_PRACTITIONER_DATA_REQUEST = 'GET_PRACTITIONER_DATA_REQUEST';
export const GET_PRACTITIONER_DATA_SUCCESS = 'GET_PRACTITIONER_DATA_SUCCESS';
export const SET_PAYMENT_DETAILS_UPDATES = 'SET_PAYMENT_DETAILS_UPDATES';
export const SET_PRACTITIONER_LANGUAGES = 'SET_PRACTITIONER_LANGUAGES';
export const ADD_PRACTITIONER_LANGUAGE = 'ADD_PRACTITIONER_LANGUAGE';
export const REMOVE_PRACTITIONER_LANGUAGE = 'REMOVE_PRACTITIONER_LANGUAGE';
export const SET_PRACTITIONER_SPECIALIZATIONS = 'SET_PRACTITIONER_SPECIALIZATIONS';
export const ADD_PRACTITIONER_SPECIALIZATION = 'ADD_PRACTITIONER_SPECIALIZATION';
export const REMOVE_PRACTITIONER_SPECIALIZATION = 'REMOVE_PRACTITIONER_SPECIALIZATION';

export interface IUserState {
    user?: IUser;
    error?: IErrorResponse | null;
}

export interface IPractitionerState {
    practitioner?: PractitionerModel;
    error?: IErrorResponse | null;
    settingsUpdated?: boolean;
    languages: LanguageModel[];
    specializations: PractitionerSpecializationModel[];
}

interface IGetPractitionerDataRequest {
    type: typeof GET_PRACTITIONER_DATA_REQUEST;
}

interface IGetPractitionerDataSuccess {
    type: typeof GET_PRACTITIONER_DATA_SUCCESS;
    payload: PractitionerModel;
}

interface IGetUserDataRequest {
    type: typeof GET_USER_DATA_REQUEST;
}

interface IGetUserDataSuccess {
    type: typeof GET_USER_DATA_SUCCESS;
    payload: IUserResponseDTO;
}

interface ISetSettingsUpdated {
    type: typeof SET_PAYMENT_DETAILS_UPDATES;
    payload: boolean;
}

interface ISetPractitionerLanguages {
    type: typeof SET_PRACTITIONER_LANGUAGES;
    payload: LanguageModel[];
}

interface IAddPractitionerLanguage {
    type: typeof ADD_PRACTITIONER_LANGUAGE;
    payload: LanguageModel;
}

interface IRemovePractitionerLanguage {
    type: typeof REMOVE_PRACTITIONER_LANGUAGE;
    payload: number;
}

interface ISetPractitionerSpecializations {
    type: typeof SET_PRACTITIONER_SPECIALIZATIONS;
    payload: PractitionerSpecializationModel[];
}

interface IAddPractitionerSpecialization {
    type: typeof ADD_PRACTITIONER_SPECIALIZATION;
    payload: PractitionerSpecializationModel;
}

interface IRemovePractitionerSpecialization {
    type: typeof REMOVE_PRACTITIONER_SPECIALIZATION;
    payload: number;
}

export type UserActionTypes = IGetUserDataRequest | IGetUserDataSuccess;
export type PractitionerActionTypes =
    | IGetPractitionerDataRequest
    | IGetPractitionerDataSuccess
    | ISetSettingsUpdated
    | ISetPractitionerLanguages
    | IAddPractitionerLanguage
    | IRemovePractitionerLanguage
    | ISetPractitionerSpecializations
    | IAddPractitionerSpecialization
    | IRemovePractitionerSpecialization;
